module.exports = __webpack_public_path__ + "static/media/W.f36de438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/W.jpg
// module id = 91
// module chunks = 0